<template>
  <div class="analysis-container" ref="pdfContainer">
    <!-- Header -->
    <PageHeader :current-page="'ai-interview'" active-side="seek" />
    <div class="main-content-wrapper">
      <div class="left-sidebar">
        <div class="applied-positions">
          <div class="sidebar-header">
            <h3>已投递岗位</h3>
          </div>

          <div class="motivation-section">
            <div class="girl-illustration">
              <img
                src="./assets/img/Comeon.png"
                alt="加油插图"
                class="girl-image"
              />
            </div>
            <div class="motivation-text">
              <h4>加油! Offer在向你招手</h4>
              <p>当前面试记录暂未投递岗位</p>
              <p>点击下方<strong>[投递更多岗位]</strong>获取更多机会吧~</p>
            </div>
          </div>

          <div class="apply-button">
            <button class="apply-more-btn" @click="goToMorePosition">
              投递更多岗位
            </button>
          </div>
        </div>
      </div>
      <div class="pdf-export-content" ref="pdfExportContent">
        <div class="main-content" ref="mainContentRef">
          <div class="recommendation-index">
            <div class="index-header">
              <h2>候选人推荐指数</h2>
              <span class="feedback-text" @click="showFeedbackModal"
                >用户反馈</span
              >
            </div>
            <div class="recommendation-content">
              <div class="advantage">
                <div class="title">优点</div>
                <div class="items-list">
                  <div
                    v-for="(item, index) in advantagesList"
                    :key="index"
                    class="item"
                  >
                    <div class="item-number">{{ index + 1 }}</div>
                    <div class="item-content">
                      <div class="item-title">{{ item.title }}</div>
                      <div class="item-desc">{{ item.desc }}</div>
                    </div>
                  </div>
                  <div v-if="advantagesList.length === 0" class="empty-state">
                    暂无优点数据
                  </div>
                </div>
              </div>
              <div class="disadvantage">
                <div class="title">缺点</div>
                <div class="items-list">
                  <div
                    v-for="(item, index) in disadvantagesList"
                    :key="index"
                    class="item"
                  >
                    <div class="item-number">{{ index + 1 }}</div>
                    <div class="item-content">
                      <div class="item-title">{{ item.title }}</div>
                      <div class="item-desc">{{ item.desc }}</div>
                    </div>
                  </div>
                  <div
                    v-if="disadvantagesList.length === 0"
                    class="empty-state"
                  >
                    暂无缺点数据
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="interview-record">
            <div class="record-header">
              <h3>面试记录</h3>
              <button class="export-btn" @click="exportInterview">
                导出面试记录
              </button>
            </div>

            <div class="interview-summary" v-if="!isShortInterview">
              <h4>总结</h4>
              <p>{{ feedbackText }}</p>
            </div>
            <template v-if="!isShortInterview">
              <div
                class="qa-section"
                v-for="(item, index) in questions"
                :key="index"
              >
                <div class="question-item">
                  <div class="question-number">{{ index + 1 }}</div>
                  <div class="question-content">
                    <h5>问题</h5>
                    <p>{{ item.question }}</p>
                  </div>
                </div>

                <div class="answer-content">
                  <h5>回答</h5>
                  <p>{{ item.answer }}</p>
                </div>

                <div class="interviewer-advice">
                  <h5>面试官建议</h5>
                  <p>{{ item.advice }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="right-section" ref="rightSectionRef">
          <div class="right-score">
            <div class="radar-header">
              <div class="radar-title">推荐指数雷达图</div>
              <div class="radar-score">
                <span class="score-value">{{ totalRadarScore }}分</span>
              </div>
            </div>
            <div ref="radarChartRef" class="radar-chart"></div>
            <PdfExporter
              ref="pdfExporter"
              :export-content-ref="'pdfExportContent'"
              :main-content-ref="'mainContentRef'"
              :right-section-ref="'rightSectionRef'"
              :right-section-selector="'.right-score'"
              :chart-instance="radarChartInstance"
              :exclude-selectors="['.analysis-btn']"
              :filename="`简历匹配分析报告_${new Date()
                .toISOString()
                .slice(0, 19)
                .replace(/:/g, '-')}.pdf`"
              :options="{
                scale: 1.2,
                backgroundColor: '#ffffff',
                radarWidthRatio: 0.7,
                layout: 'vertical',
              }"
              :show-button="true"
              button-text="简历匹配分析报告"
              button-class="analysis-btn"
              @exported="handlePdfExported"
              @error="handlePdfError"
            />
          </div>
          <div class="right-sidebar">
            <div class="recommendations">
              <div class="sidebar-header">
                <h3>为您推荐</h3>
              </div>

              <div class="recommendation-cards">
                <template v-if="displayedCards1 && displayedCards1.length > 0">
                  <div
                    v-for="(card, index) in displayedCards1"
                    :key="index"
                    class="recommendation-card"
                    @click="clickRecommendation(card)"
                  >
                    <div class="card-image">
                      <img
                        :src="
                          card.cover_url ||
                          require(`./assets/img/${card.image}`)
                        "
                        alt="推荐图片"
                      />
                    </div>
                    <div class="card-content">
                      <p class="card-description">{{ card.title }}</p>
                    </div>
                  </div>
                </template>
                <div v-else class="no-recommendation">
                  <p>暂无推荐视频</p>
                </div>
              </div>
            </div>
          </div>

          <div class="action-buttons">
            <button class="retake-interview-btn" @click="retakeInterview">
              重新面试
            </button>
            <button class="direct-recommend-btn" @click="openJobModal">
              直推企业
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showJobModal"
      class="job-modal-overlay"
      @click="showJobModal = false"
    >
      <div class="job-modal-content" @click.stop>
        <div v-if="!submit" class="job-modal-header">
          <h3>请选择你想被推荐的岗位</h3>
          <button class="job-modal-close" @click="closeJobModal">×</button>
        </div>

        <div v-if="!submit" class="job-modal-body">
          <div class="job-list">
            <div v-if="isRecommendLoading" class="loading-container">
              <div class="loading-spinner"></div>
              <div class="loading-text">正在为您推荐合适的岗位，请稍候...</div>
            </div>
            <div v-else>
              <!-- 渲染接口推荐数据 -->
              <div
                v-for="(job, index) in recommendData"
                :key="'recommend-' + index"
                class="job-entry"
              >
                <div v-if="index === 0" class="recommend-group-title">
                  {{ job.isJob ? "当前面试岗位" : "其他推荐岗位" }}
                </div>
                <div
                  v-else-if="
                    index === 1 && recommendData[0] && recommendData[0].isJob
                  "
                  class="recommend-group-title"
                >
                  其他推荐岗位
                </div>

                <div
                  class="job-card"
                  :class="{ 'applied-row': job.isDelivery }"
                >
                  <div class="job-checkbox">
                    <input
                      type="checkbox"
                      :id="'recommend-job-' + index"
                      v-model="job.selected"
                      :disabled="job.isDelivery"
                    />
                    <label :for="'recommend-job-' + index"></label>
                  </div>
                  <div class="job-content">
                    <div
                      class="job-content-main"
                      @click="toggleRecommendJobExpand(index)"
                    >
                      <div class="job-left-section">
                        <div class="job-title-row">
                          <h4 class="job-title">{{ job.job_title }}</h4>
                          <span
                            class="job-tag"
                            :class="{ 'applied-tag': job.isDelivery }"
                          >
                            {{
                              job.tagLabel ||
                              (job.isDelivery ? "已投递" : "推荐")
                            }}
                          </span>
                        </div>
                        <div class="job-company-row">
                          <div class="company-logo">
                            <img
                              v-if="job.company_logo"
                              :src="job.company_logo"
                              :alt="job.company_name"
                              class="company-logo-img"
                            />
                            <div v-else class="company-logo-text">
                              {{ getCompanyAvatar(job.company_name) }}
                            </div>
                          </div>
                          <div class="company-info">
                            <div class="company-name">
                              {{ job.company_name }}
                            </div>
                            <div class="company-details">
                              {{
                                job.job_summary?.job_category || job.industry
                              }}
                              {{ job.company_scale }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="job-right-section">
                        <div class="job-salary">
                          {{
                            job.job_summary?.salary_range ||
                            job.job_summary?.salary ||
                            "薪资面议"
                          }}
                        </div>
                        <div class="job-attributes">
                          <span class="attr-item">{{
                            getExperienceText(
                              job.job_summary?.required_experience_years
                            ) || "不限"
                          }}</span>
                          <span class="attr-item">{{
                            job.job_summary?.required_education_degree
                          }}</span>
                        </div>
                        <div class="job-location-line">
                          {{ job.city || job.location }}
                        </div>
                      </div>
                    </div>

                    <div class="job-details" v-if="job.expanded">
                      <div
                        class="job-detail-section"
                        v-if="
                          job.job_details &&
                          job.job_details.responsibilities &&
                          job.job_details.responsibilities.length
                        "
                      >
                        <h5>岗位职责</h5>
                        <ul class="detail-list">
                          <li
                            v-for="(responsibility, rIdx) in job.job_details
                              .responsibilities"
                            :key="rIdx"
                          >
                            {{ responsibility }}
                          </li>
                        </ul>
                      </div>
                      <div
                        class="job-detail-section"
                        v-if="
                          job.job_details &&
                          ((job.job_details.must_have_requirements &&
                            job.job_details.must_have_requirements.length >
                              0) ||
                            (job.job_details.preferred_requirements &&
                              job.job_details.preferred_requirements.length >
                                0))
                        "
                      >
                        <h5>岗位要求</h5>
                        <ul class="detail-list">
                          <template
                            v-if="
                              job.job_details &&
                              job.job_details.must_have_requirements &&
                              job.job_details.must_have_requirements.length > 0
                            "
                          >
                            <li
                              v-for="(requirement, reqIdx) in job.job_details
                                .must_have_requirements"
                              :key="reqIdx"
                            >
                              {{ requirement }}
                            </li>
                          </template>
                          <template
                            v-if="
                              job.job_details &&
                              job.job_details.preferred_requirements &&
                              job.job_details.preferred_requirements.length > 0
                            "
                          >
                            <li
                              v-for="(requirement, prefIdx) in job.job_details
                                .preferred_requirements"
                              :key="'pref-' + prefIdx"
                            >
                              {{ requirement }}
                            </li>
                          </template>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 渲染内置职位数据 -->
              <!-- 如果 recommendData 为空或只有一条且 isJob 为 true，显示"其他推荐岗位"标题 -->
              <div
                v-if="shouldShowOtherJobsTitle"
                class="recommend-group-title"
              >
                其他推荐岗位
              </div>
              <div v-for="(job, index) in jobs" :key="index" class="job-card">
                <div class="job-checkbox">
                  <input
                    type="checkbox"
                    :id="'job-' + index"
                    v-model="job.selected"
                  />
                  <label :for="'job-' + index"></label>
                </div>
                <div class="job-content">
                  <div class="job-content-main" @click="toggleJobExpand(index)">
                    <div class="job-left-section">
                      <div class="job-title-row">
                        <h4 class="job-title">{{ job.name }}</h4>
                        <span class="job-tag" style="color: #4fa0ff">校招</span>
                      </div>
                      <div class="job-company-row">
                        <div class="company-logo">
                          <img
                            v-if="job.company.logo"
                            :src="job.company.logo"
                            :alt="job.company.name"
                            class="company-logo-img"
                          />
                          <div v-else class="company-logo-text">
                            {{ job.company.name.charAt(0) }}
                          </div>
                        </div>
                        <div class="company-info">
                          <div class="company-name">{{ job.company.name }}</div>
                          <div class="company-details">
                            {{ job.category }} {{ job.scale }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="job-right-section">
                      <div class="job-salary">{{ job.salary }}</div>
                      <div class="job-attributes">
                        <span class="attr-item">{{ job.schedule }}</span>
                        <span class="attr-item">{{ job.duration }}</span>
                      </div>
                      <div class="job-location-line">{{ job.location }}</div>
                    </div>
                  </div>

                  <div class="job-details" v-if="job.expanded">
                    <div
                      class="job-detail-section"
                      v-if="
                        job.detail &&
                        job.detail.responsibilities &&
                        job.detail.responsibilities.length
                      "
                    >
                      <h5>工作内容</h5>
                      <ul class="detail-list">
                        <li
                          v-for="(resp, rIdx) in job.detail.responsibilities"
                          :key="rIdx"
                        >
                          {{ resp }}
                        </li>
                      </ul>
                    </div>
                    <div
                      class="job-detail-section"
                      v-if="
                        job.detail &&
                        job.detail.requirements &&
                        job.detail.requirements.length
                      "
                    >
                      <h5>任职要求</h5>
                      <ul class="detail-list">
                        <li
                          v-for="(req, qIdx) in job.detail.requirements"
                          :key="qIdx"
                        >
                          {{ req }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!submit" class="job-modal-footer">
          <div class="select-all">
            <input
              type="checkbox"
              id="selectAll"
              v-model="selectAll"
              @change="toggleSelectAll"
            />
            <label for="selectAll">全选</label>
          </div>
          <button class="submit-btn" @click="submitJobs">提交</button>
        </div>
      </div>
    </div>

    <div v-if="submit" class="success-modal-overlay" @click="closeSuccessModal">
      <div class="success-modal-content" @click.stop>
        <span class="success-close-btn" @click="closeSuccessModal">×</span>

        <div class="success-illustration">
          <img
            src="./assets/img/recommend.png"
            alt="推荐成功"
            class="success-image"
          />
        </div>

        <div class="success-content">
          <div class="success-title">
            <h2 class="title-main">表现很优秀喔~</h2>
            <h3 class="title-sub">你的简历已推荐至企业人才库!</h3>
          </div>

          <div class="success-description">
            <p class="description-text">
              请留意您的手机来电、短信及邮箱等联络方式,避<br />
              免错过沟通消息,预祝您拿下offer!
            </p>
          </div>

          <div class="progress-indicator">
            <div class="progress-step active">
              <div class="step-circle"></div>
              <span class="step-label">纳入人才库</span>
            </div>
            <div class="progress-step">
              <div class="step-circle"></div>
              <span class="step-label">优先筛选</span>
            </div>
            <div class="progress-step">
              <div class="step-circle"></div>
              <span class="step-label">拿到offer</span>
            </div>
          </div>

          <button class="success-confirm-btn" @click="closeSuccessModal">
            好的
          </button>
        </div>
      </div>
    </div>

    <FeedbackDialog
      :visible="showFeedback"
      @cancel="showFeedback = false"
      @submit="handleFeedbackSubmit"
    />

    <div
      class="download-modal"
      v-if="showDownloadModal"
      @click.self="showDownloadModal = false"
    >
      <div class="download-container">
        <div class="download-header">请选择下载选项</div>

        <div class="file-list">
          <div
            class="file-item"
            v-for="(file, index) in downloadFiles"
            :key="index"
          >
            <el-checkbox
              v-model="file.selected"
              :label="file.name"
              @change="updateSelectedFiles"
            />
          </div>
        </div>

        <div class="download-path">
          <label>下载到：</label>
          <div class="path-input-group">
            <input
              type="text"
              v-model="downloadPath"
              placeholder="请选择下载路径"
              readonly
            />
            <button class="browse-btn" @click="selectDownloadPath">浏览</button>
          </div>
        </div>

        <div class="download-summary" v-if="selectedFilesCount > 0">
          <p>
            已选择 {{ selectedFilesCount }} 个文件，总大小：{{
              totalSelectedSize
            }}
          </p>
        </div>

        <div class="download-actions">
          <button class="text-btn" @click="selectAllFiles">全选</button>
          <button class="text-btn" @click="deselectAllFiles">取消全选</button>
          <button class="outline-btn" @click="showDownloadModal = false">
            取消
          </button>
          <button
            class="primary-btn"
            @click="confirmDownload"
            :disabled="selectedFilesCount === 0"
          >
            下载 ({{ selectedFilesCount }})
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import ProgressBar from "@/components/Progress/index.vue";
import SideBar from "@/components/SideBar/index.vue";
import FeedbackDialog from "@/components/FeedbackDialog/index.vue";
import PdfExporter from "@/components/PdfExporter/index.vue";
import PageHeader from "@/components/PageHeader/index.vue";
import {
  getInterviewData,
  updateInterviewResult,
  batchCreateDelivery,
} from "@/api/mianshilishi.js";
import {
  addRecommend,
  getRecommendResult,
  getRecommendId,
  getFeedbackByInterviewId,
} from "@/api/recommend";
import {
  formatSalary,
  getEducationLabel,
  getExperienceText,
} from "@/constants/jobConstants";
import { getDefaultDownloadPath } from "@/utils/downloadPath";
export default {
  components: {
    ProgressBar,
    SideBar,
    FeedbackDialog,
    PageHeader,
    PdfExporter,
  },

  data() {
    return {
      submit: false,
      selectedJobs: [],
      isAllSelected: false,
      activeJobId: null,
      showJobDialog: false,
      allscore: 0,
      position: "",
      recommendData: [],
      isRecommendLoading: false,
      recommendPollingTimer: null,
      isShortInterview: false,
      radarChartInstance: null,
      isExportingPdf: false,
      reportUrl: "",
      jobs: [
      ],
      rightBottomStyle: {
        width: "0px",
        height: "0px",
        borderRadius: "0px",
      },
      showDownloadModal: false,
      downloadPath: getDefaultDownloadPath(),
      downloadFiles: [],
      videoBlob: null,
      textBlob: null,
      selectedFilesCount: 0,
      totalSelectedSize: 0,
      body_language: 0,
      facial_expression: 0,
      grooming: 0,
      interview_tone: 0,
      timely_response: 0,
      response_content: 0,
      progress: 50,
      showPanel: false,
      showFeedback: false,
      cards1: [
        {
          image: "img1.png",
          title: "一个产品经理的科普视频...做产品是需要天赋的",
          likes: 1303,
          stars: 2303,
          link: "https://www.bilibili.com/video/BV1Mm4y1Z7En/?spm_id_from=333.337.search-card.all.click",
        },
        {
          image: "img2.png",
          title: "投资是怎样赚钱的，什么是正确的投资方法",
          likes: 22303,
          stars: 12303,
          link: "https://www.bilibili.com/festival/jzj2023?bvid=BV1e8411B7w7&spm_id_from=333.337.search-card.all.click",
        },
        {
          image: "img3.png",
          title: "全新产品经理入门零基础课程全集课程",
          likes: 4323,
          stars: 8473,
          link: "https://www.bilibili.com/video/BV1kv4y1W7SQ/?spm_id_from=333.337.search-card.all.click",
        },
      ],
      questions: [
        {
          question: "同学你好，先介绍一下你自己",
          answer:
            "尊敬的面试官，您好!我叫肖伟。非常荣幸能够参加今天的面试。我毕业于上海交大，所学专业是数字媒体艺术。在大学期间，我不仅努力学习专业知识，还积极参加各种社团活动和实践项目，这极大地锻炼了我的团队协作能力和沟通能力。",
          advice: "缺少工作经历或实习经历的介绍。",
        },
        {
          question: "为什么选择我们公司？",
          answer: "因为贵公司在行业内有很高的知名度...",
          advice: "需要更具体的公司业务关联",
        },
        {
          question: "你的职业规划是什么？",
          answer: "希望在未来三年内成长为专业领域的专家...",
          advice: "建议增加短期目标描述",
        },
      ],
      showAnalysisModal: false,
      showJobModal: false,
      jobList: [],
      selectAll: false,
      scores: {
        沟通表达: 0,
        逻辑思维: 0,
        专业能力: 0,
        抗压能力: 0,
        成长潜力: 0,
        岗位匹配度: 0,
      },
      interviewSummary: "",
      feedbackText: "",
      advantagesList: [
        {
          title: "逻辑思维清晰",
          desc: "能够条理清晰地分析问题，回答有理有据，思路连贯。",
        },
        {
          title: "沟通表达能力强",
          desc: "语言组织流畅，表达准确，能清晰阐述自己的想法。",
        },
      ],
      disadvantagesList: [
        {
          title: "实践项目经验不足",
          desc: "缺乏大型项目经验，解决复杂业务场景的能力需要提升。",
        },
        {
          title: "算法能力需加强",
          desc: "算法基础薄弱，在解决算法问题时思路不够清晰。",
        },
      ],
      appliedJobIds: [],
    };
  },
  async mounted() {
    this.checkShortInterview();
    while (this.questions.length > 0) {
      this.questions.pop();
    }
    let score = 0;
    this.interviewSummary = this.$store.state.interviewState.interviewSummary;
    this.reportUrl = this.$store.state.interviewState.reportUrl;

    // 获取评分数据
    const interviewScoreObj = this.$store.state.interviewState.interviewScore;
    const interviewScore = interviewScoreObj?.scores;
    this.feedbackText = interviewScoreObj?.feedbackText;
    if (typeof interviewScoreObj?.totalScore === "number") {
      score = Number(interviewScoreObj.totalScore.toFixed(1));
    }

    // 获取优缺点数据
    const storeAdvantages = this.$store.state.interviewState.advantages;
    const storeDisadvantages = this.$store.state.interviewState.disadvantages;
    if (
      storeAdvantages &&
      Array.isArray(storeAdvantages) &&
      storeAdvantages.length > 0
    ) {
      this.advantagesList = storeAdvantages;
    }
    if (
      storeDisadvantages &&
      Array.isArray(storeDisadvantages) &&
      storeDisadvantages.length > 0
    ) {
      this.disadvantagesList = storeDisadvantages;
    }

    if (interviewScore && typeof interviewScore === "object") {
      const normalized = { ...interviewScore };
      if (
        normalized["问题解决与逻辑思维"] !== undefined &&
        normalized["逻辑思维"] === undefined
      ) {
        normalized["逻辑思维"] = normalized["问题解决与逻辑思维"];
        delete normalized["问题解决与逻辑思维"];
      }
      if (
        normalized["抗压性与应变能力"] !== undefined &&
        normalized["抗压能力"] === undefined
      ) {
        normalized["抗压能力"] = normalized["抗压性与应变能力"];
        delete normalized["抗压性与应变能力"];
      }
      this.scores = normalized;
      this.$set(this, "scores", normalized);
      console.log("设置 scores 为:", this.scores);
    } else {
      // 暂不回落到本地默认数据，等待后续接口尝试
      this.scores = this.scores || {};
    }
    if (
      this.$store.state.interviewState.dialogues &&
      this.$store.state.interviewState.dialogues.length > 0
    ) {
      while (this.questions.length > 0) {
        this.questions.pop();
      }
      const dialogues = this.$store.state.interviewState.dialogues;

      for (let i = 0; i < dialogues.length; i += 3) {
        const question = {
          question: dialogues[i],
          answer: dialogues[i + 1],
          advice: dialogues[i + 2],
        };
        this.questions.push(question);
      }

      score =
        this.$store.state.interviewState.interviewScore.totalScore?.toFixed(1);
      this.openJobModal();
    } else if (this.interviewId) {
      const interviewData = await this.loadData(this.interviewId);
      if (interviewData) {
        while (this.questions.length > 0) {
          this.questions.pop();
        }
        if (
          interviewData.qa_analysis &&
          Array.isArray(interviewData.qa_analysis)
        ) {
          interviewData.qa_analysis.forEach((qa) => {
            const question = {
              question: qa.question,
              answer: qa.answer,
              advice: qa.feedback,
            };
            this.questions.push(question);
          });
          if (!this.feedbackText && interviewData.interview_summary) {
            this.feedbackText = interviewData.interview_summary;
          }
        } else if (interviewData.answer_content_desc) {
          console.log("使用旧格式answer_content_desc");
          const dialogues = JSON.parse(interviewData.answer_content_desc);
          for (let i = 0; i < dialogues.length; i += 3) {
            const question = {
              question: dialogues[i],
              answer: dialogues[i + 1],
              advice: dialogues[i + 2],
            };
            this.questions.push(question);
          }
          if (!this.feedbackText && interviewData.interview_summary) {
            this.feedbackText = interviewData.interview_summary;
          }
        } else {
          console.log("面试数据格式不匹配，interviewData:", interviewData);
        }

        // 提取优缺点数据（如果 store 中没有，则从接口获取）
        if (
          interviewData.advantages &&
          Array.isArray(interviewData.advantages)
        ) {
          if (!this.advantagesList || this.advantagesList.length === 0) {
            this.advantagesList = interviewData.advantages;
            this.$store.dispatch(
              "interviewState/setAdvantages",
              interviewData.advantages
            );
          }
        }
        if (
          interviewData.disadvantages &&
          Array.isArray(interviewData.disadvantages)
        ) {
          if (!this.disadvantagesList || this.disadvantagesList.length === 0) {
            this.disadvantagesList = interviewData.disadvantages;
            this.$store.dispatch(
              "interviewState/setDisadvantages",
              interviewData.disadvantages
            );
          }
        }
      } else {
        console.log("接口返回数据为空");
      }
      const res = await getFeedbackByInterviewId({
        interview_id: this.interviewId,
      });
      if (res.data.code === 1 && res.data.data) {
        const ability = res.data.data.abilityAnalysis || {};
        this.feedbackText = ability.feedbackText || this.feedbackText;
        const mappedScores = {
          沟通表达:
            ability.communicationScore ?? this.scores?.["沟通表达"] ?? 0,
          逻辑思维: ability.logicScore ?? this.scores?.["逻辑思维"] ?? 0,
          专业能力: ability.skillScore ?? this.scores?.["专业能力"] ?? 0,
          抗压能力: ability.stressScore ?? this.scores?.["抗压能力"] ?? 0,
          成长潜力: ability.potentialScore ?? this.scores?.["成长潜力"] ?? 0,
          岗位匹配度: ability.matchScore ?? this.scores?.["岗位匹配度"] ?? 0,
        };
        this.scores = mappedScores;
        if (typeof ability.totalScore === "number") {
          score = Number(ability.totalScore.toFixed(1));
        }
        this.reportUrl = ability.reportUrl;
        this.recommendData = JSON.parse(
          res.data.data.recommendations.recommendJobs
        );

        // 处理推荐视频，如果没有返回则保持默认值（cards1 在 data 中已有默认值）
        const recommendVideosData =
          res.data.data.recommendations?.recommendVideos;
        if (recommendVideosData) {
          try {
            const parsedVideos = JSON.parse(recommendVideosData);
            if (Array.isArray(parsedVideos) && parsedVideos.length > 0) {
              this.dealVedios(parsedVideos);
            }
            // 如果解析后为空数组，dealVedios 不会修改 cards1，保持默认值
          } catch (e) {
            console.warn("解析推荐视频数据失败，保持默认值:", e);
            // 解析失败时，cards1 保持默认值不变
          }
        }
        // 如果没有返回 recommendVideos，cards1 保持默认值不变

        // 提取优缺点数据（如果 store 中没有，则从接口获取）
        const advantage = res.data.data?.abilityAnalysis?.advantage;
        const disadvantage = res.data.data?.abilityAnalysis?.disadvantage;
        if (advantage) {
          try {
            const parsedAdvantages =
              typeof advantage === "string" ? JSON.parse(advantage) : advantage;
            if (Array.isArray(parsedAdvantages)) {
              this.advantagesList = parsedAdvantages;
              this.$store.dispatch(
                "interviewState/setAdvantages",
                parsedAdvantages
              );
            }
          } catch (e) {
            console.warn("解析优点数据失败:", e);
          }
        }

        if (disadvantage) {
          try {
            const parsedDisadvantages =
              typeof disadvantage === "string"
                ? JSON.parse(disadvantage)
                : disadvantage;
            if (Array.isArray(parsedDisadvantages)) {
              this.disadvantagesList = parsedDisadvantages;
              this.$store.dispatch(
                "interviewState/setDisadvantages",
                parsedDisadvantages
              );
            }
          } catch (e) {
            console.warn("解析缺点数据失败:", e);
          }
        }
      } else {
        if (!this.scores || Object.keys(this.scores).length === 0) {
          this.scores = {
            沟通表达: 0,
            逻辑思维: 0,
            专业能力: 0,
            抗压能力: 0,
            成长潜力: 0,
            岗位匹配度: 0,
          };
        } else {
          this.scores = this.scores || {};
        }
      }
    }

    this.allscore = score;
    if (this.allscore >= 60) this.showJobDialog = true;

    if (this.questions.length == 0) {
      const question = {
        question: "没有检测到面试对话",
        answer: "没有检测到面试对话",
        advice: "没有检测到面试对话",
      };
      this.questions.push(question);
    }

    if (!this.interviewId) {
      await this.getRecommendData();
      this.hydrateCardsFromStore();
    }
    if (this.isShortInterview) {
      this.showFeedback = true;
    }

    this.jobList = [
      {
        title: "产品经理",
        tag: "热门",
        companyLogo: "JD",
        companyName: "京东",
        industry: "互联网",
        salary: "15-25K",
        type: "全职",
        education: "本科",
        experience: "3-5年",
        category: "产品",
        location: "北京",
        selected: false,
      },
      {
        title: "数据分析师",
        tag: "推荐",
        companyLogo: "BD",
        companyName: "百度",
        industry: "互联网",
        salary: "12-20K",
        type: "全职",
        education: "本科",
        experience: "2-4年",
        category: "数据",
        location: "北京",
        selected: false,
      },
      {
        title: "前端开发工程师",
        tag: "急招",
        companyLogo: "MT",
        companyName: "美团",
        industry: "互联网",
        salary: "18-30K",
        type: "全职",
        education: "本科",
        experience: "3-6年",
        category: "技术",
        location: "北京",
        selected: false,
      },
    ];

    this.selectedJobs = [];

    this.jobs.forEach((job) => {
      this.$set(job, "selected", false);
      this.$set(job, "expanded", false);
    });
    this.recommendData.forEach((job) => {
      this.$set(job, "selected", false);
      this.$set(job, "expanded", false);
    });

    window.addEventListener("resize", this.handleChartResize);
    this.$nextTick(() => {
      this.getRightElement();
      // 延迟渲染雷达图，确保 DOM 完全渲染
      setTimeout(() => {
        this.renderRadarChart();
      }, 200);
    });
  },
  computed: {
    interviewId() {
      return this.$route.params.id;
    },
    displayedCards1() {
      if (!Array.isArray(this.cards1)) return [];
      return this.cards1.slice(0, 3);
    },
    // 动态生成评分配置
    dynamicScoreConfig() {
      if (!this.scores || typeof this.scores !== "object") {
        return [];
      }
      return Object.keys(this.scores).map((key, index) => ({
        key: key,
        label: key,
        value: this.scores[key],
        index: index,
      }));
    },
    totalRadarScore() {
      const storeScore =
        this.$store?.state?.interviewState?.interviewScore?.totalScore;
      const baseScore =
        typeof this.allscore === "number" && !Number.isNaN(this.allscore)
          ? this.allscore
          : storeScore;
      return Math.max(0, Math.floor(baseScore || 0));
    },
    // 判断是否应该显示"其他推荐岗位"标题
    shouldShowOtherJobsTitle() {
      // 如果 recommendData 为空数组
      if (!this.recommendData || this.recommendData.length === 0) {
        return true;
      }
      // 如果 recommendData 只有一条且 isJob 为 true
      if (
        this.recommendData.length === 1 &&
        this.recommendData[0]?.isJob === true
      ) {
        return true;
      }
      return false;
    },
  },

  watch: {
    selectedJobs(val) {
      const totalJobs = this.recommendData.length + this.jobs.length;
      this.selectAll = val.length === totalJobs;
    },

    "$route.params.id"(newVal) {
      this.loadData(newVal);
    },
    scores: {
      deep: true,
      handler() {
        this.$nextTick(() => this.renderRadarChart());
      },
    },
    allscore() {
      this.$nextTick(() => this.renderRadarChart());
    },
  },
  beforeDestroy() {
    this.stopRecommendPolling();
    window.removeEventListener("resize", this.handleChartResize);
    if (this.radarChartInstance) {
      this.radarChartInstance.dispose();
      this.radarChartInstance = null;
    }
  },
  created() {
    try {
      const raw = localStorage.getItem("jobInformation");
      if (raw) {
        const { position } = JSON.parse(raw) || {};

        this.position = position;
      }
    } catch (e) {
      console.warn("jobInformation 不存在", e);
    }
  },
  methods: {
    getExperienceText,

    clickRecommendation(card) {
      if (card.link) {
        window.open(card.link);
      }
    },

    toggleJobExpand(index) {
      const job = this.jobs[index];
      if (!job) return;
      job.expanded = !job.expanded;
      if (job.expanded) {
        this.jobs.forEach((j, i) => {
          if (i !== index) j.expanded = false;
        });

        this.recommendData.forEach((j) => (j.expanded = false));
      } else {
      }
    },

    toggleRecommendJobExpand(index) {
      const job = this.recommendData[index];
      if (!job) return;
      job.expanded = !job.expanded;

      if (job.expanded) {
        this.recommendData.forEach((j, i) => {
          if (i !== index) j.expanded = false;
        });

        this.jobs.forEach((j) => (j.expanded = false));
      } else {
      }
    },
    goToMorePosition() {
      sessionStorage.setItem("redirectToHotJobs", "true");
      this.$router.push("/");
    },
    async submitSelection() {
      try {
        if (this.selectedJobs.length === 0) {
          this.$message.warning("请至少选择一个职位");
          return;
        }

        const recommendArray = [];

        for (const selectedJobLabel of this.selectedJobs) {
          // 检查是否是接口数据（格式：公司名-职位名）
          if (selectedJobLabel.includes("-")) {
            // 通过职位标题反向匹配，避免公司名中的"-"被错误分割
            let foundJob = null;
            let companyName = "";
            let jobTitle = "";
            // 遍历所有职位，找到匹配的职位标题
            for (const job of this.recommendData) {
              if (selectedJobLabel.endsWith(`-${job.job_title}`)) {
                foundJob = job;
                jobTitle = job.job_title;
                companyName = selectedJobLabel.substring(
                  0,
                  selectedJobLabel.length - job.job_title.length - 1
                );
                break;
              }
            }
            if (foundJob) {
              console.log(
                "interview_id",
                this.$store.state.interviewState.interviewId
              );

              // 构建推荐对象
              recommendArray.push({
                company_id: foundJob.company_id || null,
                evaluation_score: this.allscore,
                interview_duration:
                  this.$store.state.interviewState.actualInterviewDuration,
                interview_position: this.position || "未知职位",
                interview_time: Date.now(),
                interview_id: this.$store.state.interviewState.interviewId,
                job_id: foundJob.job_id,
              });
            }
          } else {
            // 处理只有职位名的情况 - 先尝试在接口数据中查找
            let job = this.recommendData.find(
              (j) => j.job_title === selectedJobLabel
            );

            if (job) {
              console.log(
                "interview_id",
                this.$store.state.interviewState.interviewId
              );
              // 在接口数据中找到，构建推荐对象
              recommendArray.push({
                company_id: job.company_id || null,
                evaluation_score: this.allscore,
                interview_duration:
                  this.$store.state.interviewState.actualInterviewDuration,
                interview_position: this.position || "未知职位",
                interview_time: Date.now(),
                interview_id: this.$store.state.interviewState.interviewId,
                job_id: job.job_id,
              });
            } else {
              // 如果接口数据中没找到，尝试在内置数据中查找
              const defaultJob = this.jobs.find(
                (j) => j.name === selectedJobLabel
              );
              if (defaultJob) {
                console.log(
                  "interview_id",
                  this.$store.state.interviewState.interviewId
                );
                // 为内置数据构建推荐对象
                recommendArray.push({
                  company_id: 1,
                  evaluation_score: this.allscore,
                  interview_duration:
                    this.$store.state.interviewState.actualInterviewDuration,
                  interview_position: this.position || "未知职位",
                  interview_time: Date.now(),
                  interview_id: this.$store.state.interviewState.interviewId,
                  job_id: 1,
                });
              }
            }
          }
        }
        if (recommendArray.length > 0) {
          const { data } = await addRecommend(recommendArray);
          console.log("推荐提交结果:", data);
        }

        this.submit = true;
        // this.$message.success('推荐提交成功！');
      } catch (error) {
        console.error("提交推荐失败:", error);
        // this.$message.error('提交推荐失败，请重试');
      }
    },
    handleSelectAll(checked) {
      if (checked) {
        // 全选：接口数据 + 内置数据
        const apiJobLabels = this.recommendData.map(
          (job) => `${job.company_name}-${job.job_title}`
        );
        const defaultJobLabels = this.jobs.map((job) => job.name);
        this.selectedJobs = [...apiJobLabels, ...defaultJobLabels];
      } else {
        // 取消全选
        this.selectedJobs = [];
      }
    },
    navigateToProfile() {
      this.$router.push("/store/dashboard/profile");
    },

    getRightElement() {
      const rightElement = this.$refs.rightElement;
      if (rightElement) {
        const width = rightElement.clientWidth;
        const height = rightElement.clientHeight;

        const computedStyle = window.getComputedStyle(rightElement);
        const borderRadius = computedStyle.borderRadius;
        const borderWidth = computedStyle.borderWidth;

        return {
          width,
          height,
          borderRadius,
          borderWidth,
        };
      }
    },

    buildRadarChartData() {
      const scoreSource =
        this.scores && typeof this.scores === "object" ? this.scores : {};

      // 直接使用 scores 对象构建雷达图数据
      const radarData = [
        {
          name: "岗位匹配度",
          value: Math.round(Number(scoreSource["岗位匹配度"]) || 0),
        }, // 固定假数据
        { name: "成长潜力", value: Number(scoreSource["成长潜力"]) || 0 },
        { name: "逻辑思维", value: Number(scoreSource["逻辑思维"]) || 0 },
        { name: "专业能力", value: Number(scoreSource["专业能力"]) || 0 },
        { name: "抗压能力", value: Number(scoreSource["抗压能力"]) || 0 },
        { name: "沟通表达", value: Number(scoreSource["沟通表达"]) || 0 },
      ];

      return radarData.map((item) => ({
        name: item.name,
        value: Math.max(0, Math.min(100, item.value)),
        max: 100,
      }));
    },

    renderRadarChart() {
      const chartContainer = this.$refs.radarChartRef;
      if (!chartContainer) return;

      // 检查 DOM 是否已渲染且有尺寸
      const width = chartContainer.clientWidth || chartContainer.offsetWidth;
      const height = chartContainer.clientHeight || chartContainer.offsetHeight;

      if (width === 0 || height === 0) {
        // 尝试设置最小尺寸
        if (height === 0) {
          chartContainer.style.height = "360px";
        }
        if (width === 0) {
          chartContainer.style.width = "100%";
        }
        this.$nextTick(() => {
          setTimeout(() => this.renderRadarChart(), 200);
        });
        return;
      }

      // 如果实例已存在但容器尺寸变化，先销毁再重新创建
      if (this.radarChartInstance) {
        this.radarChartInstance.dispose();
        this.radarChartInstance = null;
      }

      try {
        this.radarChartInstance = echarts.init(chartContainer);
      } catch (error) {
        console.error("初始化 ECharts 失败:", error);
        return;
      }

      const radarData = this.buildRadarChartData();

      if (!radarData.length) {
        this.radarChartInstance.clear();
        return;
      }

      // 修改指标名称，显示分数和文字（两行）
      const indicators = radarData.map((item) => ({
        name: `${item.value}\n${item.name}`,
        max: item.max,
      }));
      const values = radarData.map((item) => item.value);
      const gradientFill = new echarts.graphic.LinearGradient(0, 0, 1, 0, [
        { offset: 0, color: "rgba(126, 180, 235, 0.65)" },
        { offset: 1, color: "rgba(177, 110, 249, 0.65)" },
      ]);

      const option = {
        tooltip: {
          show: false,
        },
        radar: {
          indicator: indicators,
          center: ["50%", "50%"],
          radius: "60%",
          axisNameGap: 8,
          splitNumber: 5,
          splitLine: {
            lineStyle: {
              color: [
                "rgba(117, 135, 255, 0.15)",
                "rgba(117, 135, 255, 0.25)",
                "rgba(117, 135, 255, 0.3)",
                "rgba(117, 135, 255, 0.4)",
                "rgba(117, 135, 255, 0.5)",
              ],
            },
          },
          splitArea: {
            areaStyle: {
              color: "#ffffff",
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(117, 135, 255, 0.35)",
            },
          },
          axisName: {
            color: "#6C6F93",
            fontSize: 12,
            formatter: function (value) {
              // value 是格式化后的名称（包含分数和文字）
              // 使用换行符分隔，第一行是分数，第二行是文字
              const parts = value.split("\n");
              if (parts.length === 2) {
                // 第一行显示分数，加粗
                return `{score|${parts[0]}}\n{text|${parts[1]}}`;
              }
              return value;
            },
            rich: {
              score: {
                fontSize: 14,
                fontWeight: 600,
                color: "#5b61ff",
                lineHeight: 18,
              },
              text: {
                fontSize: 12,
                color: "#6C6F93",
                lineHeight: 16,
              },
            },
            padding: [4, 8],
            show: true,
          },
        },
        series: [
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 4,
            itemStyle: {
              color: "#7EB4EB",
            },
            lineStyle: {
              color: "#7EB4EB",
              width: 2,
            },
            areaStyle: {
              color: gradientFill,
              opacity: 0.7,
            },
            data: [
              {
                value: values,
              },
            ],
          },
        ],
      };

      try {
        this.radarChartInstance.setOption(option, true);
        // 确保图表正确渲染
        this.radarChartInstance.resize();
      } catch (error) {
        console.error("设置雷达图选项失败:", error);
      }
    },

    handleChartResize() {
      if (this.radarChartInstance) {
        this.radarChartInstance.resize();
      }
    },

    // 响应式调整

    exportInterview() {
      // 从store中获取文件数据
      const interviewState = this.$store.state.interviewState;

      // 检查是否有可下载的文件
      if (
        interviewState.processedVideoBlob ||
        interviewState.processedTextBlob
      ) {
        this.videoBlob = interviewState.processedVideoBlob;
        this.textBlob = interviewState.processedTextBlob;

        // 更新下载文件列表
        this.downloadFiles = [];
        if (this.videoBlob) {
          this.downloadFiles.push({
            name: `面试视频 (${this.formatFileSize(this.videoBlob.size)})`,
            selected: true,
            size: this.videoBlob.size,
            type: "video",
            blob: this.videoBlob,
          });
        }
        if (this.textBlob) {
          this.downloadFiles.push({
            name: `面试对话记录 (${this.formatFileSize(this.textBlob.size)})`,
            selected: true,
            size: this.textBlob.size,
            type: "text",
            blob: this.textBlob,
          });
        }

        // 初始化选择状态
        this.updateSelectedFiles();

        // 显示下载弹窗
        this.showDownloadModal = true;
      } else {
        this.$message.warning("暂无可下载的文件，请先完成面试录制");
      }
    },
    setAsDefaultPath() {
      alert("已设为默认下载路径");
    },
    confirmDownload() {
      try {
        const selectedFiles = this.downloadFiles.filter(
          (file) => file.selected
        );

        if (selectedFiles.length === 0) {
          this.$message.warning("请至少选择一个文件进行下载");
          return;
        }

        // 下载选中的文件
        selectedFiles.forEach((file) => {
          const url = URL.createObjectURL(file.blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;

          // 根据文件类型设置文件名
          if (file.type === "video") {
            a.download = `面试视频_${new Date()
              .toISOString()
              .slice(0, 19)
              .replace(/:/g, "-")}.mp4`;
          } else if (file.type === "text") {
            a.download = `面试对话记录_${new Date()
              .toISOString()
              .slice(0, 19)
              .replace(/:/g, "-")}.txt`;
          }

          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        });

        this.$message.success(`成功下载 ${selectedFiles.length} 个文件！`);
        this.showDownloadModal = false;
      } catch (error) {
        console.error("下载失败:", error);
        this.$message.error("下载失败，请重试！");
      }
    },
    gotomianshilishi() {
      this.$router.push("/interview_mianshilishi");
      setTimeout(() => {
        window.location.reload();
      }, 50);
    },
    async handleFeedbackSubmit(data) {
      // 处理提交反馈的逻辑
      if (!data.feedbackText || !data.feedbackText.trim()) {
        this.$message.warning("请输入反馈内容");
        return;
      }

      try {
        // 调用反馈提交API
        const { submitFeedback } = require("@/api/user.js");
        await submitFeedback({
          rating: data.emojiIndex,
          feedback_content: data.feedbackText,
          interview_id: this.$store.state.interviewState.interviewId,
        });
        this.$message.success("感谢您的反馈！");
        this.showFeedback = false;
      } catch (error) {
        console.error("提交反馈失败:", error);
        this.$message.error("提交反馈失败，请稍后重试");
      }
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    // 更新选中的文件
    updateSelectedFiles() {
      this.selectedFilesCount = this.downloadFiles.filter(
        (file) => file.selected
      ).length;
      this.totalSelectedSize = this.formatFileSize(
        this.downloadFiles
          .filter((file) => file.selected)
          .reduce((total, file) => total + file.size, 0)
      );
    },

    // 全选文件
    selectAllFiles() {
      this.downloadFiles.forEach((file) => (file.selected = true));
      this.updateSelectedFiles();
    },

    // 取消全选文件
    deselectAllFiles() {
      this.downloadFiles.forEach((file) => (file.selected = false));
      this.updateSelectedFiles();
    },

    // 选择下载路径
    selectDownloadPath() {
      // 由于浏览器安全限制，我们提供一个输入框让用户手动输入路径
      const platform = navigator.platform || navigator.userAgent;
      const userAgent = navigator.userAgent.toLowerCase();
      let examplePath = "D:\\Downloads";
      if (platform.includes('Mac') || userAgent.includes('mac')) {
        examplePath = "~/Downloads";
      } else if (platform.includes('Linux') || userAgent.includes('linux')) {
        examplePath = "~/Downloads";
      }
      const newPath = prompt(
        `请输入下载路径（例如：${examplePath}）：`,
        this.downloadPath
      );
      if (newPath && newPath.trim()) {
        this.downloadPath = newPath.trim();
        this.$message.success("下载路径已更新");
      }
    },

    handlePdfExported(filename) {
      console.log("[PDF导出] PDF 导出成功:", filename);
    },

    handlePdfError(error) {
      console.error("[PDF导出] PDF 导出失败:", error);
    },

    // 加载面试数据
    async loadData(interviewId) {
      try {
        const { data } = await getInterviewData(interviewId);
        if (data.code == 1) {
          return data.data; // 返回数据以供后续处理
        }
      } catch (error) {
        console.error("加载面试数据失败:", error);
      }
    },

    // 从反馈数据更新评分
    updateScoresFromFeedback(feedbackData) {
      if (feedbackData && feedbackData.scores) {
        // 直接更新scores对象
        this.scores = feedbackData.scores || {};
      } else {
        // 确保scores始终是一个对象
        this.scores = this.scores || {};
      }
    },

    // 处理推荐岗位，并将当前面试岗位插入到第一条
    handleRecommendJobs(rawJobs) {
      // 克隆后端返回的推荐岗位列表，避免直接修改入参
      let jobs = Array.isArray(rawJobs)
        ? JSON.parse(JSON.stringify(rawJobs))
        : [];
      const currentJob =
        this.$store?.state?.interviewState?.currentInterviewJob;

      if (currentJob) {
        const currentJobId =
          currentJob.job_id || currentJob.id || currentJob.jobId || null;

        // 如果当前面试岗位有 job_id，则先把与之重复的推荐岗位过滤掉（避免在「其他推荐岗位」里再次出现）
        if (currentJobId != null) {
          const idStr = String(currentJobId);
          jobs = jobs.filter((job) => {
            const jid = job?.job_id ?? job?.id ?? job?.jobId;
            return String(jid) !== idStr;
          });
        }

        // 将当前面试岗位插入到列表首位，用 isJob 标记为当前岗位
        jobs.unshift({
          ...currentJob,
          job_id: currentJobId,
          company_id: currentJob.company_id || currentJob.companyId,
          isJob: true,
          job_title: currentJob.title,
          job_summary: {
            job_category: currentJob.category,
            salary:
              currentJob.salary ||
              formatSalary(
                currentJob.salary_start,
                currentJob.salary_end,
                currentJob.salary_month
              ),
            required_education_degree: getEducationLabel(currentJob.education),
            required_experience_years: currentJob.experience,
          },
          job_details: {
            responsibilities: [currentJob.description],
            must_have_requirements: [currentJob.requirement],
          },
        });
        if (this.$store?.dispatch) {
          this.$store.dispatch("interviewState/clearCurrentInterviewJob");
        } else if (this.$store?.commit) {
          this.$store.commit("interviewState/CLEAR_CURRENT_INTERVIEW_JOB");
        }
      }
      return jobs;
    },

    // 获取推荐数据
    async getRecommendData() {
      try {
        let recommendId = this.$store.state.interviewState.recommendId;
        if (!recommendId) {
          console.log("没有推荐任务ID，开始获取推荐ID");

          // 调用getRecommendId接口获取推荐ID
          try {
            const { data } = await getRecommendId({
              jd_url: this.$store.state.interviewState.jd?.url || "",
              resume_url: this.$store.state.interviewState.cv?.url || "",
              total_num: 10,
            });

            if (data.code === 1) {
              // 将任务ID存储到Vuex中
              this.$store.dispatch("interviewState/setRecommendId", data.msg);
              recommendId = data.msg;
            } else {
              console.error("获取推荐任务ID失败:", data.msg);
              return;
            }
          } catch (error) {
            console.error("调用getRecommendId接口失败:", error);
            return;
          }
        }
        const { data } = await getRecommendResult({ recommendId });
        let recommendJobs = [];
        if (data.code === 1) {
          if (data.data === null) {
            // 数据为null，停止loading，显示本地数据
            this.isRecommendLoading = false;
            recommendJobs = [];
            console.log("推荐数据为空，显示本地数据");
          } else {
            // 数据不为null，停止轮询并显示数据
            this.stopRecommendPolling();
            this.isRecommendLoading = false;
            recommendJobs = JSON.parse(data.data);

            recommendJobs.forEach((job) => {
              this.$set(job, "selected", false);
              this.$set(job, "expanded", false);
            });
            console.log("推荐数据获取成功:", this.recommendData);
          }
        } else {
          console.error("获取推荐数据失败:", data.msg);
          // 获取失败时也显示本地数据
          this.isRecommendLoading = false;
          recommendJobs = [];
        }
        recommendJobs = this.handleRecommendJobs(recommendJobs);
        this.recommendData = recommendJobs;
        await updateInterviewResult({
          interview_id:
            this.$store.state.interviewState.interviewId || this.interviewId,
          recommend_job_position_json: JSON.stringify(recommendJobs),
          recommend_video_json: JSON.stringify(
            this.$store.state.interviewState.recommendVideos || ""
          ),
        });
      } catch (error) {
        console.error("调用推荐结果API失败:", error);
        // 出错时也显示本地数据
        this.isRecommendLoading = false;
        this.recommendData = [];
      }
    },

    // 使用 store 中的推荐视频渲染
    hydrateCardsFromStore() {
      const videos = this.$store.state.interviewState.recommendVideos || [];
      if (videos.length === 0) return;
      this.dealVedios(videos);
    },

    dealVedios(videos) {
      // 如果 videos 为空或不是数组，不修改 cards1
      if (!Array.isArray(videos) || videos.length === 0) {
        return;
      }
      this.cards1 = videos.map((item) => ({
        image: "img1.png",
        title: item.title,
        likes: item.likes || 0,
        stars: item.views || 0,
        link: item.video_url,
        cover_url: item.cover_url,
        video_url: item.video_url,
      }));
    },

    // 开始推荐数据轮询
    startRecommendPolling(recommendId) {
      this.stopRecommendPolling(); // 先清除之前的定时器
      this.recommendPollingTimer = setInterval(async () => {
        try {
          const { data } = await getRecommendResult({ recommendId });

          if (data.code === 1 && data.data !== null) {
            // 数据不为null，停止轮询并显示数据
            this.stopRecommendPolling();
            this.isRecommendLoading = false;
            this.recommendData = JSON.parse(data.data);
            // 为推荐数据添加selected和expanded属性
            this.recommendData.forEach((job) => {
              this.$set(job, "selected", false);
              this.$set(job, "expanded", false);
            });
            console.log("推荐数据轮询获取成功:", this.recommendData);
          }
        } catch (error) {
          console.error("轮询推荐结果API失败:", error);
        }
      }, 4000); // 4秒轮询一次
    },

    // 停止推荐数据轮询
    stopRecommendPolling() {
      if (this.recommendPollingTimer) {
        clearInterval(this.recommendPollingTimer);
        this.recommendPollingTimer = null;
      }
    },

    // 转换教育程度代码为文本
    getEducationText(educationCode) {
      const educationMap = {
        1: "大专",
        2: "本科",
        3: "硕士",
        4: "博士",
        5: "不限",
      };
      return educationMap[educationCode] || "不限";
    },

    // 获取公司头像（显示公司名称前两个字，去掉地名前缀）
    getCompanyAvatar(companyName) {
      if (!companyName) return "公司";

      // 去掉地名前缀（匹配"XX市"、"XX省"等格式）
      let cleanName = companyName.replace(/^[^省市区县]+[省市县区]/, "");

      return cleanName.substring(0, 2);
    },

    // 跳转到更多岗位页面
    goToMorePosition() {
      sessionStorage.setItem("redirectToHotJobs", "true");
      this.$router.push("/");
    },

    // 检查是否为短面试（低于3分钟）
    checkShortInterview() {
      // 方法1：通过URL查询参数判断
      if (this.$route.query.short === "1") {
        this.isShortInterview = true;
        return;
      }

      // 方法2：通过store中的实际面试时长判断
      const actualDuration =
        this.$store.state.interviewState.actualInterviewDuration;
      if (actualDuration && actualDuration < 3) {
        this.isShortInterview = true;
        return;
      }
      // 方法3：通过面试时长配置判断（如果实际时长不可用）
      const interviewDuration =
        this.$store.state.interviewState.interviewDuration;
      if (interviewDuration && interviewDuration < 3) {
        this.isShortInterview = true;
        return;
      }
      // 默认不是短面试
      this.isShortInterview = false;
    },

    // 全选/取消全选岗位
    toggleSelectAll() {
      this.jobs.forEach((job) => {
        job.selected = this.selectAll;
      });
      this.recommendData.forEach((job) => {
        job.selected = this.selectAll;
      });
    },

    // 提交岗位选择
    async submitJobs() {
      if (!Array.isArray(this.jobs)) this.jobs = [];
      if (!Array.isArray(this.recommendData)) this.recommendData = [];

      const selectedJobs = this.jobs.filter((job) => job.selected);
      const selectedRecommendJobs = this.recommendData.filter(
        (job) => job.selected
      );

      if (selectedJobs.length === 0 && selectedRecommendJobs.length === 0) {
        this.$message.warning("请至少选择一个岗位");
        return;
      }

      try {
        const deliveryArray = [];
        const jobIdToJobMap = new Map();

        // 处理选中的推荐岗位
        for (const selectedJob of selectedRecommendJobs) {
          const deliveryItem = {
            job_id: selectedJob.job_id,
            interview_id:
              this.$store.state.interviewState.interviewId || this.interviewId,
            company_id:
              selectedJob.company_id || selectedJob.company_profile.company_id,
            receiver_type: 4,
          };
          deliveryArray.push(deliveryItem);
          jobIdToJobMap.set(selectedJob.job_id, selectedJob);
        }

        // 处理选中的内置数据
        for (const selectedJob of selectedJobs) {
          const deliveryItem = {
            job_id: 1, // 内置数据的默认职位ID
            interview_id:
              this.$store.state.interviewState.interviewId || this.interviewId,
            company_id: 1, // 内置数据的默认公司ID
            receiver_type: 4,
          };
          deliveryArray.push(deliveryItem);
          // 保存映射关系（内置数据使用 job_id: 1）
          jobIdToJobMap.set(1, selectedJob);
        }

        if (deliveryArray.length > 0) {
          const { data } = await batchCreateDelivery(deliveryArray);
          if (data.code === 1 || data.code === 0) {
            const resultData = data.data || {};
            const successCount = resultData.success_count || 0;
            const failCount = resultData.fail_count || 0;
            const successJobIds = resultData.success_job_ids || [];
            const failDetails = resultData.fail_details || [];

            // 处理成功投递的岗位，设置已投递状态
            if (successJobIds.length > 0) {
              const successJobIdsSet = new Set(successJobIds);

              successJobIdsSet.forEach((jobId) => {
                const job = jobIdToJobMap.get(jobId);
                if (job) {
                  this.$set(job, "isDelivery", true);
                  this.$set(job, "selected", false);
                }
              });

              this.recommendData.forEach((job) => {
                if (successJobIdsSet.has(job.job_id)) {
                  this.$set(job, "isDelivery", true);
                  this.$set(job, "selected", false);
                }
              });

              this.jobs.forEach((job) => {
                if (successJobIdsSet.has(1) && job.selected) {
                  this.$set(job, "isDelivery", true);
                  this.$set(job, "selected", false);
                }
              });
            }

            const failReasonMessages = [];
            if (failDetails.length > 0) {
              failDetails.forEach((failDetail) => {
                const jobId = failDetail.job_id;
                const reason = failDetail.reason || "未知原因";

                // 根据 job_id 找到对应的岗位信息
                const job = jobIdToJobMap.get(jobId);
                if (job) {
                  const jobTitle = job.job_title || job.title || "未知岗位";
                  const companyName = job.company_name || "未知公司";
                  failReasonMessages.push(
                    `${companyName}-${jobTitle}：${reason}`
                  );
                } else {
                  failReasonMessages.push(`岗位ID ${jobId}：${reason}`);
                }
              });
            }

            if (successCount > 0 && failCount === 0) {
              await updateInterviewResult({
                interview_id:
                  this.$store.state.interviewState.interviewId ||
                  this.interviewId,
                recommend_job_position_json: JSON.stringify(this.recommendData),
              });
              this.submit = true;
            } else if (successCount > 0 && failCount > 0) {
              await updateInterviewResult({
                interview_id:
                  this.$store.state.interviewState.interviewId ||
                  this.interviewId,
                recommend_job_position_json: JSON.stringify(this.recommendData),
              });
              if (failReasonMessages.length > 0) {
                const failReason = failReasonMessages.join("<br>");
                const message = `成功${successCount}条，失败${failCount}条.<br>${failReason}`;
                this.$message({
                  message: message,
                  type: "warning",
                  dangerouslyUseHTMLString: true,
                  duration: 5000,
                });
              }
            } else if (failCount > 0) {
              if (failReasonMessages.length > 0) {
                const failReason = failReasonMessages.join("<br>");
                const message = `成功${successCount}条，失败${failCount}条.<br>${failReason}`;
                this.$message({
                  message: message,
                  type: "error",
                  dangerouslyUseHTMLString: true,
                  duration: 5000,
                });
              }
            }
          } else {
            throw new Error(data.msg || "投递失败");
          }
        }
      } catch (error) {
        console.error("提交推荐失败:", error);
        this.$message.error(error.message || "提交推荐失败，请重试");
      }
    },

    openJobModal() {
      this.submit = false;
      this.showJobModal = true;
    },

    closeJobModal() {
      this.submit = false;
      this.showJobModal = false;
    },
    closeSuccessModal() {
      this.submit = false;
    },

    // 重新面试
    retakeInterview() {
      this.$router.push("/store/dashboard/profile");
    },

    showFeedbackModal() {
      this.showFeedback = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$gradient-primary: linear-gradient(90deg, #62afff 0%, #9c41ff 100%);
$gradient-secondary: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%);

$text-primary: #656587;

.analysis-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: url("./assets/img/_1-10.png") no-repeat center center;
  background-size: cover;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  position: relative;
}

.analysis-container > .main-content-wrapper {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  overflow: auto;
  width: 100%;
}

.left-sidebar {
  width: 280px;
  background: #fff;
  border-radius: 12px;
  margin: 20px;
  margin-right: 0px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 85vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  margin-top: 40px;
}

.applied-positions {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.applied-positions::-webkit-scrollbar {
  display: none;
}

.sidebar-header h3 {
  color: $text-primary;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
}

.motivation-section {
  text-align: center;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.girl-illustration {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.girl-image {
  max-width: 100%;
  max-height: 60%;
  /* height: auto; */
  /* max-height: 120px; */
  object-fit: contain;
}

.motivation-text {
  margin-top: -90px;
}

.motivation-text h4 {
  background: $gradient-secondary;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.motivation-text p {
  color: $text-primary;
  font-size: 14px;
  margin: 4px 0;
  line-height: 1.4;
}

.apply-more-btn {
  width: 100%;
  background: $gradient-secondary;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.apply-more-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
}

/* PDF 导出内容容器 - 不影响原有展示样式 */
.pdf-export-content {
  display: contents; /* 使用 contents 让容器不参与布局，保持原有样式 */
}

.main-content {
  flex: 1;
  margin: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 85vh;
  overflow-y: auto;
  max-width: 800px;
  margin-top: 40px;
}

.recommendation-index {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.recommendation-content {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  .title {
    color: #656587;
    font-size: 16px;
    padding: 16px 16px 12px 16px;
    font-weight: 700;
  }
  .advantage {
    flex: 1;
    border-radius: 16px;
    box-shadow: 4px 4px 20px 0px #0000000d;
    border-top: 2px solid #39b76e;
    height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  }
  .advantage::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
  .disadvantage {
    flex: 1;
    border-radius: 16px;
    box-shadow: 4px 4px 20px 0px #0000000d;
    border-top: 2px solid #f45c5c;
    height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  }
  .disadvantage::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
  .items-list {
    padding: 0 16px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }
  .item-number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
  }
  .advantage .item-number {
    background: rgba(57, 183, 110, 0.15);
    color: #39b76e;
  }
  .disadvantage .item-number {
    background: rgba(244, 92, 92, 0.15);
    color: #f45c5c;
  }
  .item-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .item-title {
    font-size: 14px;
    font-weight: 600;
    color: #656587;
    line-height: 1.4;
  }
  .item-desc {
    font-size: 13px;
    color: #8a90b4;
    line-height: 1.5;
  }
  .empty-state {
    padding: 20px;
    text-align: center;
    color: #8a90b4;
    font-size: 14px;
  }
}

.index-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.index-header h2 {
  color: $text-primary;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.performance-metrics {
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-right: 180px;
}

.metric-item {
  margin-bottom: 0;
}

.metric-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.metric-label {
  color: $text-primary;
  font-size: 14px;
  font-weight: 500;
}

.metric-score {
  color: $text-primary;
  font-size: 14px;
  font-weight: 600;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: $gradient-secondary;
  border-radius: 3px;
  transition: width 0.3s ease;
}

.index-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.analysis-btn {
  width: 100%;
  background: $gradient-secondary;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.analysis-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
}

.analysis-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.index-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
}
.index-actions .user-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pdf-tools {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
}
.pdf-select {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 12px;
  color: #656587;
  background: #fff;
}

.user-feedback {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.score-image {
  position: absolute !important;
  bottom: -20px !important;
  right: -180px !important;
  width: 150px !important;
  height: 150px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  z-index: 1 !important;
}

.score-image img {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  display: block !important;
}

.score-text {
  position: absolute !important;
  bottom: 22px !important;
  right: -110px !important;
  background: $gradient-secondary;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 32px !important;
  font-weight: 800 !important;
  z-index: 2 !important;
  font-family: "Afacad-Bold", sans-serif !important;
}

.feedback-text {
  background: $gradient-secondary;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 14px;
  cursor: pointer;
}

/* 面试记录 */
.interview-record {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex: 1;
  overflow-y: auto;
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.record-header h3 {
  color: $text-primary;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.export-btn {
  background: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: $gradient-secondary;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.interview-summary {
  margin-bottom: 24px;
  padding: 16px;
  background: linear-gradient(
    90deg,
    rgba(98, 175, 255, 0.1) 0%,
    rgba(156, 65, 255, 0.1) 100%
  );
  border-radius: 8px;
}

.interview-summary h4 {
  color: $text-primary;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.interview-summary p {
  color: $text-primary;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

.qa-section {
  margin-bottom: 24px;
  /* 避免单个问答块在生成 PDF 时被拆成两页 */
  page-break-inside: avoid;
  break-inside: avoid;
}

.question-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  /* 避免问题编号 + 文本被拆到不同页 */
  page-break-inside: avoid;
  break-inside: avoid;
}

.question-number {
  width: 24px;
  height: 24px;
  background: linear-gradient(
    90deg,
    rgba(98, 175, 255, 0.1) 0%,
    rgba(156, 65, 255, 0.1) 100%
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #656587;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.question-content {
  /* 让内容在 flex 布局下可以收缩并自动换行 */
  flex: 1;
  min-width: 0;
  /* 尽量保证问题整体不要被拆页 */
  page-break-inside: avoid;
  break-inside: avoid;
}

.question-content h5 {
  color: #656587;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.question-content p {
  color: #656587;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

.answer-content {
  margin-left: 36px;
  margin-bottom: 16px;
}

.answer-content h5 {
  color: #656587;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.answer-content p {
  color: #656587;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

.interviewer-advice {
  background: linear-gradient(
    90deg,
    rgba(98, 175, 255, 0.1) 0%,
    rgba(156, 65, 255, 0.1) 100%
  );
  border: 1px solid rgba(98, 175, 255, 0.2);
  border-radius: 0 8px 8px 0;
  padding: 16px;
  margin-left: 22px;
  position: relative;
}

.interviewer-advice::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  background: linear-gradient(
    180deg,
    rgba(177, 110, 249, 0.6) 0%,
    rgba(126, 180, 235, 0.6) 100%
  );
  border-radius: 0 2px 2px 0;
}

.interviewer-advice h5 {
  color: #656587;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.interviewer-advice p {
  color: #656587;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

/* 右侧边栏 */
.right-score {
  width: 320px;
  flex: 0 0 48%;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.radar-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.radar-title {
  font-size: 28px;
  color: #656587;
  font-weight: 700;
}
.radar-score {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.2;
}
.radar-score .score-value {
  font-size: 28px;
  font-weight: 700;
  color: #5b61ff;
}
.radar-score .score-label {
  font-size: 14px;
  color: #8a90b4;
  margin-top: 4px;
}
.radar-chart {
  width: 100% !important;
  min-width: 280px;
  height: 280px !important;
  min-height: 280px;
  box-sizing: border-box;
  display: block;
}
.right-sidebar {
  width: 320px;
  background: #fff;
  border-radius: 12px;
  margin: 0;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex: 0 0 38%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.recommendations {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.recommendation-cards {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.recommendation-cards::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

.no-recommendation {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #8a90b4;
  font-size: 14px;
  text-align: center;
}

.recommendation-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.2s ease;
  width: 100%;
  max-width: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.recommendation-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.card-image {
  width: 100%;
  height: auto;
  min-height: 120px;
  max-height: 200px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.recommendation-card:hover .card-image img {
  transform: scale(1.05);
}

.card-content {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 0;
  overflow: hidden;
}

.card-description {
  color: $text-primary;
  font-size: 12px;
  line-height: 1.4;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.apply-button {
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
  margin-bottom: -10px;
}

.right-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 20px 20px 20px 0;
  height: 85vh;
  margin-top: 40px;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 320px;
  border-radius: 12px;
  box-sizing: border-box;
}

.retake-interview-btn {
  background: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: $gradient-secondary;
  border: 2px solid;
  border-image: $gradient-secondary 1;
  border-radius: 12px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
}

.direct-recommend-btn {
  background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
}

.direct-recommend-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
}

@media (max-width: 1200px) {
  .analysis-container {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
  }

  .left-sidebar,
  .right-sidebar {
    width: 100%;
    margin: 10px;
    height: auto;
  }

  .main-content {
    margin: 10px;
    height: auto;
  }
}

@media (max-width: 768px) {
  .analysis-container {
    height: auto;
    min-height: 100vh;
  }

  .left-sidebar,
  .right-sidebar,
  .main-content {
    margin: 5px;
    height: auto;
  }

  .recommendation-index,
  .interview-record {
    padding: 16px;
  }

  .index-actions {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
}

.analysis-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.analysis-modal-content {
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.analysis-modal-header {
  background: $gradient-secondary;
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-radius: 36px 36px 0 0;
}

.analysis-modal-header h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  flex: 1;
  text-align: center;
}

.analysis-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.analysis-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.analysis-modal-body {
  background-color: #fff;
  padding: 24px;
  flex: 1;
  overflow-y: auto;
}

.evaluation-section {
  margin-bottom: 24px;
  padding: 16px;
  background: linear-gradient(
    90deg,
    rgba(98, 175, 255, 0.1) 0%,
    rgba(156, 65, 255, 0.1) 100%
  );
  border-radius: 8px;
}

.evaluation-section h4 {
  color: $text-primary;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.evaluation-section p {
  color: $text-primary;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

.scoring-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.scoring-section .score-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.scoring-section .score-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.scoring-section .score-label {
  color: $text-primary;
  font-size: 14px;
  font-weight: 500;
}

.scoring-section .score-value {
  color: $text-primary;
  font-size: 14px;
  font-weight: 600;
}

.scoring-section .score-progress {
  width: 100%;
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.scoring-section .score-fill {
  height: 100%;
  background: $gradient-secondary;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.analysis-modal-footer {
  padding: 20px 24px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
}

.close-btn {
  width: 100%;
  background: $gradient-secondary;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.close-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
}

@media (max-width: 768px) {
  .analysis-modal-content {
    width: 95%;
    margin: 20px;
  }

  .analysis-modal-header {
    padding: 16px 20px;
  }

  .analysis-modal-header h3 {
    font-size: 16px;
  }

  .analysis-modal-body {
    padding: 20px;
  }

  .analysis-modal-footer {
    padding: 16px 20px;
  }
}

.job-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.job-modal-content {
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}

.job-modal-header {
  background: $gradient-secondary;
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 36px 36px 0 0;
  flex-shrink: 0;
}

.job-modal-header h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.job-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.job-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.job-modal-body {
  background-color: #fff;
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  min-height: 0;
}

.job-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.job-entry {
  margin-bottom: 12px;
}

.recommend-group-title {
  font-size: 15px;
  font-weight: 600;
  color: #6b6e91;
  margin: 12px 0 8px;
}

.job-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  transition: all 0.2s ease;
  margin: 20px 0;
}

.job-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.job-checkbox {
  margin-top: 4px;
}

.job-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  appearance: none;
  /* border: 2px solid #ddd; */
  box-shadow: 0px 0px 4px 0px #65658740 inset;
  border-radius: 4px;
  background: #fff;
  position: relative;
  transition: all 0.2s ease;
}

.job-checkbox input[type="checkbox"]:checked {
  background: $gradient-primary;
}

.job-checkbox input[type="checkbox"]:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.job-checkbox input[type="checkbox"]:disabled {
  cursor: not-allowed;
  background: #eef0f6;
  box-shadow: none;
  border: 1px solid #d7d9e3;
}

.job-checkbox input[type="checkbox"]:disabled::after {
  display: none;
}

.job-checkbox input[type="checkbox"]:disabled + label {
  cursor: not-allowed;
  opacity: 0.6;
}

.job-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.job-content-main {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.job-left-section {
  flex: 1;
}

.job-right-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  min-width: 120px;
}

.job-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.job-card.applied-row {
  background: #f5f6fb;
  border-color: #e1e3ee;
  box-shadow: none;
}

.job-card.applied-row .job-title,
.job-card.applied-row .company-name,
.job-card.applied-row .company-details,
.job-card.applied-row .job-salary,
.job-card.applied-row .attr-item,
.job-card.applied-row .job-location-line {
  color: #a7a9bd;
}

.job-card.applied-row .job-tag {
  background: #e7e8f2;
  color: #9c9fb3;
}

.job-card.applied-row .job-content-main {
  pointer-events: none;
}

.job-card.applied-row:hover {
  box-shadow: none;
}

.job-title {
  font-size: 16px;
  font-weight: 600;
  color: $text-primary;
  margin: 0;
}

.job-tag {
  background: #e3f2fd;
  color: $text-primary;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.job-tag.current-tag {
  background: linear-gradient(
    90deg,
    rgba(126, 180, 235, 1) 0%,
    rgba(177, 110, 249, 1) 100%
  );
  color: #ffffff;
}

.job-tag.applied-tag {
  background: rgba(63, 187, 126, 0.15);
  color: #39b76e;
}

.expand-icon {
  margin-left: auto;
  font-size: 12px;
  color: #4fa0ff;
  cursor: pointer;
}

.job-company-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.company-logo {
  width: 32px;
  height: 32px;
  background: #4caf50;
  color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.company-logo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.company-logo-text {
  font-size: 12px;
  font-weight: 600;
}

.job-details {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.job-detail-section {
  margin-bottom: 10px;
}

.job-detail-section h5 {
  margin: 0 0 6px 0;
  font-size: 16px;
  font-weight: 600;
  color: #656587;
}

.detail-text {
  margin: 0;
  font-size: 13px;
  color: #656587;
  line-height: 1.5;
}

.detail-list {
  margin: 0;
  padding-left: 18px;
  color: #656587;
  font-size: 16px;
}

.success-dialog {
  display: flex;
  align-items: center;
  padding: 25px;
  min-height: 400px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.95) 100%
  );
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
}

.success-close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  color: white;
  font-size: 18px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.success-close-btn:hover {
  background: linear-gradient(90deg, #6ba3e8 0%, #a55df5 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.6), rgba(132, 172, 237, 0.6));
  transform: scale(1.1);
}

.success-illustration {
  flex: 0 0 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 25px;
}

.success-image {
  width: 160px;
  height: auto;
  border-radius: 12px;
}

.success-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.success-title {
  margin-bottom: 20px;
}

.title-main {
  font-size: 24px;
  font-weight: 700;
  color: #656587;
  margin: 0 0 8px 0;
  font-family: "Afacad", sans-serif;
}

.title-sub {
  font-size: 18px;
  font-weight: 600;
  color: #656587;
  margin: 0;
  font-family: "Afacad", sans-serif;
}

.success-description {
  margin-bottom: 30px;
}

.description-text {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
  font-family: "Afacad", sans-serif;
}

.progress-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  position: relative;
}

.progress-indicator::before {
  content: "";
  position: absolute;
  top: 12px;
  left: 12px;
  right: 12px;
  height: 2px;
  background: linear-gradient(90deg, #8b5cf6 0%, #e5e7eb 100%);
  z-index: 1;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  flex: 1;
}

.step-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e5e7eb;
  border: 3px solid #e5e7eb;
  margin-bottom: 8px;
  transition: all 0.3s ease;
}

.progress-step.active .step-circle {
  background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  border-color: #8b5cf6;
  box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.2);
}

.step-label {
  font-size: 12px;
  color: #6b7280;
  text-align: center;
  font-family: "Afacad", sans-serif;
  font-weight: 500;
}

.progress-step.active .step-label {
  color: #8b5cf6;
  font-weight: 600;
}

.success-confirm-btn {
  background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  color: white;
  border: none;
  border-radius: 12px;
  padding: 14px 0;
  font-size: 16px;
  font-weight: 600;
  font-family: "Afacad", sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
  width: 100%;
  text-align: center;
}

.success-confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.4);
}

.success-confirm-btn:active {
  transform: translateY(0);
}

/* 推荐成功弹窗样式 */
.success-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.success-modal-content {
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 25px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.95) 100%
  );
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
}

.company-info {
  flex: 1;
}

.company-name {
  font-size: 14px;
  font-weight: 500;
  color: $text-primary;
  margin-bottom: 2px;
}

.company-details {
  font-size: 12px;
  color: $text-primary;
}

.job-salary {
  font-size: 20px;
  font-weight: 800;
  background: $gradient-secondary;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.job-attributes {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.attr-item {
  background: #f5f5f5;
  color: $text-primary;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}

.job-location {
  font-size: 12px;
  color: $text-primary;
}

.job-location-line {
  font-size: 12px;
  color: $text-primary;
  text-align: right;
}

.job-modal-footer {
  padding: 20px 24px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  min-height: 60px;
}

.select-all {
  display: flex;
  align-items: center;
  gap: 8px;
}

.select-all input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.select-all label {
  font-size: 14px;
  color: $text-primary;
  cursor: pointer;
}

.submit-btn {
  background: $gradient-secondary;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.submit-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
}

@media (max-width: 768px) {
  .job-modal-content {
    width: 95%;
    margin: 20px;
  }

  .job-modal-header {
    padding: 16px 20px;
  }

  .job-modal-body {
    padding: 16px;
  }

  .job-modal-footer {
    padding: 16px 20px;
  }

  .job-card {
    flex-direction: column;
    gap: 12px;
  }

  .job-company-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.download-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.download-container {
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 24px 32px;
  border-radius: 12px;
  width: 680px;
  min-height: 400px;
  max-height: 80%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-family: "PingFang SC", "Helvetica Neue", sans-serif;
}

.download-header {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.file-list {
  margin-bottom: 20px;
  background: linear-gradient(
    180deg,
    rgba(177, 110, 249, 0.2) 0%,
    rgba(126, 180, 235, 0.2) 100%
  );
  border-radius: 12px;
}

.file-item {
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.file-item:last-child {
  border-bottom: none;
}

.download-path {
  display: flex;
  align-items: center;
  gap: 8px;
}

.download-path label {
  display: block;
  font-size: 14px;
  margin-bottom: 6px;
  color: #666;
}

.download-path input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.download-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.text-btn {
  background: none;
  border: none;
  color: #1890ff;
  cursor: pointer;
  font-size: 14px;
}

.outline-btn {
  padding: 6px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  background: linear-gradient(
    180deg,
    rgba(177, 110, 249, 0.2) 0%,
    rgba(126, 180, 235, 0.2) 100%
  );
  border-radius: 30px;
  height: 51px;
  width: 83px;
  font-size: 12px;
}

.primary-btn {
  border: 1px solid #d9d9d9;
  border-radius: 30px;
  height: 51px;
  width: 83px;
  font-size: 12px;
  padding: 6px 20px;
  border-radius: 6px;
  cursor: pointer;
  background: linear-gradient(
    180deg,
    rgba(177, 110, 249, 0.6) 0%,
    rgba(126, 180, 235, 0.6) 100%
  );
}

.primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.path-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.path-input-group input[type="text"] {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.browse-btn {
  background: linear-gradient(90deg, #7eb4eb, #b16ef9);
  color: white;
  border: none;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.browse-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.download-summary {
  margin: 15px 0;
  padding: 10px;
  background: rgba(177, 110, 249, 0.1);
  border-radius: 8px;
  border-left: 4px solid #b16ef9;
}

.download-summary p {
  margin: 0;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.el-checkbox {
  width: 100%;
}

.el-checkbox__label {
  font-size: 14px;
  color: #333;
}
</style>
